import { render, staticRenderFns } from "./paintList.vue?vue&type=template&id=7b6a34be"
import script from "./paintList.vue?vue&type=script&lang=js"
export * from "./paintList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports